module.exports = __webpack_public_path__ + "img/refused.d27fa26c.png";